import { getPersonData } from "../../utils/myinfoData";
import { Box, Typography, useTheme } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { tokens } from "../../theme";
import TableAdminLoanRequest from "../../components/TableAdminLoanRequest";
import React, { useState, useEffect, useRef } from "react";
import Cookies from "js-cookie";
import warn_ico from "../../assets/img/exclamation.png";
import { useHistory } from "react-router-dom";
import {
  Form,
  Input,
  Select,
  Col,
  Row,
  Avatar,
  Upload,
  Card,
  Tabs,
  notification,
  DatePicker,
  Space,
  InputNumber,
  Modal,
  Button,
} from "antd";
import { EyeTwoTone, EyeInvisibleOutlined } from "@ant-design/icons";
import { Collapse, message } from "antd";
import { format } from "date-fns";
import LocalPoliceIcon from "@mui/icons-material/LocalPolice";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  PDFDownloadLink,
  Font,
  PDFViewer,
} from "@react-pdf/renderer";
import logo from "../../assets/img/SL-01.png";
import boldFont from "../../assets/font/Poppins-SemiBold.ttf";
import ProfileViewer from "../../pages/borrower-dashboard/ProfileViewer";
import { CircularProgress } from "@mui/material";
import { ToastContainer, toast } from "react-toastify";

Font.register({
  family: "Poppins",
  fonts: [
    { src: boldFont, fontWeight: 700 }, // Bold (700)
  ],
});

const RequestedLoan = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [sortBy, setSortBy] = useState("default");
  const [dataModalIsOpen, setDataModalIsOpen] = useState(false);
  const [openModalData, setOpenModalData] = useState(null);
  const [channel, setChannel] = useState("system");
  const [data, setData] = useState([]);
  const [subject, setSubject] = useState("");
  const { TextArea } = Input;
  const [selectedBorrowerIds, setselectedBorrowerIds] = useState([]);
  const history = useHistory();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [passwordConfirmation, setConfirmPassword] = useState("");
  const [visible, setVisible] = useState(false);
  const [visible2, setVisible2] = useState(false);
  const [error, setError] = useState("");
  const [screenWidth, setScreenWidth] = useState("1920");
  const [removeLoan, setRemoveLoan] = useState(1);
  const [rejectReasons, setRejectReasons] = useState(null);
  const [editLoanRemarkModalIsOpen, setEditLoanRemarkModalIsOpen] =
    useState(false);
  const [editBorrowerNotesModalIsOpen, setEditBorrowerNotesModalIsOpen] =
    useState(false);

  const [notesLoanId, setNotesLoanId] = useState("");

  const [remarkDetails, setRemarkDetails] = useState(null);
  const [borrowerNotes, setBorrowerNotes] = useState("");

  const [allLenders, setAllLenders] = useState([]);
  const [isMobile, setIsMobile] = useState(
    Cookies.get("ismobile") === "yes" ? true : false
  );

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    // Call handleResize initially to set the initial screen width
    handleResize();

    // Add event listener for resize
    window.addEventListener("resize", handleResize);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (screenWidth < 1200) {
      Cookies.set("ismobile", "yes");
      setIsMobile(true);
    } else {
      Cookies.set("ismobile", "no");
      setIsMobile(false);
    }
  }, [screenWidth]);
  // const [allUser, setAllUser] = useState([]);

  const fileInputRef = useRef(null);
  const pendingLoanIdRef = useRef(null); // <-- use ref instead of state (no async)
  const pendingBnameRef = useRef(null); // <-- use ref instead of state (no async)

  const handleClickUpload = (loanId, e, bname) => {
    e.stopPropagation();
    pendingLoanIdRef.current = loanId; // set synchronously
    pendingBnameRef.current = bname;
    fileInputRef.current?.click(); // open file picker
  };

  const handleFileChange = async (e) => {
    const file = e.target.files?.[0];
    const loanId = pendingLoanIdRef.current; // read synchronously
    console.log(file);
    console.log(loanId);

    if (!file || !loanId) return;

    try {
      await uploadFileToDoc(file, loanId);
    } finally {
      e.target.value = ""; // allow choosing same file again
      pendingLoanIdRef.current = null;
    }
  };

  const uploadFileToDoc = async (file, loanId) => {
    const fileData = new FormData();
    fileData.append("file", file);
    fileData.append("type", "loan");
    fileData.append("file_id", loanId);
    try {
      const uploadToLoanFolder = await fetch(
        "https://www.smart-lend.com/api/file/uploadUniversalFile",
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
          body: fileData,
        }
      );
      if (uploadToLoanFolder.status === 200) {
        const filedaata = await uploadToLoanFolder.json();
        console.log(filedaata);
        informAllLenderOfNewDocument(
          filedaata.original_filename,
          pendingBnameRef.current
        );
        toast.success("Upload succesful");
      } else {
        toast.warn("Something went wrong, please try again.");
      }
    } catch (error) {
      console.error(error);
    }
  };

  const informAllLenderOfNewDocument = async (document_name, borrower_name) => {
    try {
      const response = await fetch(
        "https://www.smart-lend.com/api/loan/informAllLenderOfNewDocument",
        {
          method: "POST",
          headers: {
            Authorization: "Bearer " + Cookies.get("token"),
            Accept: "application/json",
            "Content-Type": "application/json", 
          },
          body: JSON.stringify({
            document_name: document_name,
            borrower_name: borrower_name,
          }),
        }
      );
      const json = await response.json();
    } catch (error) {
      console.error(error);
    }
  };

  const fetchLenders = async () => {
    try {
      const response = await fetch(
        "https://www.smart-lend.com/api/user/getAllUser",
        {
          method: "GET",
          headers: {
            Authorization: "Bearer " + Cookies.get("token"),
            Accept: "application/json",
          },
        }
      );
      const json = await response.json();
      setAllLenders(json["Lender"]);
    } catch (error) {
      console.error(error);
    }
  };

  useState(() => {
    fetchLenders();
  }, []);

  const editLoanNotes = async (loan_id, notes) => {
    try {
      console.log(loan_id, remarkDetails);
      const response = await fetch(
        `https://www.smart-lend.com/api/loan/editLoanNotes`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
          body: JSON.stringify({
            loan_id: loan_id,
            platform_notes: notes,
          }),
        }
      );
      const jsonData = await response.json();

      if (response.status === 200) {
        handleRowClick({ loan_id: loan_id });
        message.success("Platform notes updated !");
        setBorrowerNotes("");
        setEditBorrowerNotesModalIsOpen(false);
      }
    } catch (error) {
      console.error("Error editing loan remarks:", error);
    }
  };

  const seditLoanRemarks = async (loan_id, remarkDetails) => {
    try {
      console.log(loan_id, remarkDetails);
      const response = await fetch(
        `https://www.smart-lend.com/api/admin/editLoanRemarks`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            loan_id: loan_id,
            loan_remark: JSON.stringify(remarkDetails),
          }),
        }
      );
      const jsonData = await response.json();

      if (response.status === 200) {
        handleRowClick({ loan_id: loan_id });
        message.success("Loan remarks updated !");
        setRemarkDetails(null);
        setEditLoanRemarkModalIsOpen(false);
      }
    } catch (error) {
      console.error("Error editing loan remarks:", error);
    }
  };
  const [isLoading, setIsLoading] = useState(false);

  const downloadLoanDocuments = async (loanId) => {
    try {
      setIsLoading(true);
      const response = await fetch(
        "https://www.smart-lend.com/api/download-loan-documents",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
          body: JSON.stringify({ loan_id: loanId }),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        alert(`Download failed: ${data.message}`);
        return;
      }

      const downloadUrl = data.download_url;

      // Create a link and simulate click to download the file
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.setAttribute("download", "loan_documents.zip"); // Optional: suggested filename
      document.body.appendChild(link);
      link.click();
      link.remove();
      setIsLoading(false);
    } catch (err) {
      console.error("Error downloading zip:", err);
      alert("An error occurred while downloading the ZIP.");
    }
  };

  const overwriteLoanAuthentications = async (loanId) => {
    try {
      setIsLoading(true);
      const response = await fetch(
        "https://www.smart-lend.com/api/adminLoan/overWriteLoanAuthentication",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
          body: JSON.stringify({ loan_id: loanId }),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        message.error("Failed to overwrite Loan Authentications");
        return;
      } else {
        message.success("Loan Authentication succesfully overwritten!");
        setIsLoading(false);
      }
    } catch (err) {
      console.error("Error downloading zip:", err);
      alert("An error occurred while downloading the ZIP.");
    }
  };

  const handleRowClick = async (record) => {
    const loan_id = record.loan_id;
    try {
      const response = await fetch(
        `https://www.smart-lend.com/api/loan/loanRequest/viewLoanRequestDetail?loan_id=${loan_id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      );
      const data = await response.json();

      const parsedData = data["Loan Detail"].map((item) => {
        const updatedItem = {
          ...item,
          credit_report_data: JSON.parse(item.credit_report_data),
        };

        // Parse credit_report_data in loan_authorizations array
        const updatedLoanAuthorizations = item.loan_authorizations.map(
          (authorization) => ({
            ...authorization,
            credit_report_data: JSON.parse(authorization.credit_report_data),
          })
        );

        // Update the item with the updated loan_authorizations array
        updatedItem.loan_authorizations = updatedLoanAuthorizations;

        return updatedItem;
      });

      console.log(parsedData);
      setData(parsedData);
    } catch (error) {
      console.error("Error retrieving Loan Detail Data:", error);
    }
  };

  const handleAdminRemoval = async ({ loan_id, boolean }) => {
    try {
      const response = await fetch(
        `https://www.smart-lend.com/api/loan/adminRemoveLoanRequest`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
          body: JSON.stringify({ loan_id: loan_id, admin_removal: boolean }),
        }
      );
      const jsonData = await response.json();

      if (response.status === 200) {
        if (boolean) {
          message.success("Admin removal Successful!");
          const updatingLoan = [...data];
          updatingLoan[0].admin_removal = boolean;
          setData(updatingLoan);
        } else {
          message.success("Loan back in market!");
          const updatingLoan = [...data];
          updatingLoan[0].admin_removal = boolean;
          setData(updatingLoan);
        }
      }
    } catch (error) {
      console.error("Error retrieving Loan Detail Data:", error);
    }
  };

  const handleLoanDelete = async (loan_id) => {
    try {
      const response = await fetch(
        `https://www.smart-lend.com/api/loan/adminDeleteLoanRequest`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
          body: JSON.stringify({ loan_id: loan_id }),
        }
      );
      const jsonData = await response.json();

      if (response.status === 200) {
        message.success("Loan deleted Successful!");
        let updatingLoanRemoved = removeLoan;
        updatingLoanRemoved += 1;
        setRemoveLoan(updatingLoanRemoved);
        setData([]);
      }
    } catch (error) {
      console.error("Error retrieving Loan Detail Data:", error);
    }
  };

  const handleSelectionChange = (selectedBorrowerIds) => {
    console.log("Selected loan IDs:", selectedBorrowerIds);
    setselectedBorrowerIds(selectedBorrowerIds);
  };

  const formatDate = (dateString) => {
    try {
      if (!dateString) throw new Error("No date string provided");

      const date = new Date(dateString);
      if (isNaN(date.getTime())) throw new Error("Invalid date string");

      const formattedDate = format(date, "dd MMMM yyyy");

      return formattedDate;
    } catch (error) {
      console.error(error);
      return "-";
    }
  };

  useEffect(() => {
    // To redirect user if not authenticated
    const isAuthenticated = Cookies.get("token");
    const user_account_type = Cookies.get("user_account_type");

    if (!isAuthenticated) {
      history.push("/auth/signin");
    } else if (user_account_type === "lender") {
      history.push("/dashboard");
    } else if (user_account_type === "borrower") {
      history.push("/b-dashboard");
    }
  }, [history]);

  const layout = {
    labelCol: {
      span: 24,
    },
    wrapperCol: {
      span: 16,
    },
    vertical: true,
  };

  const onFinish = (values) => {
    console.log("Success:", values);
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const tailLayout = {
    wrapperCol: {
      offset: 9,
      span: 24,
    },
  };

  const [dataSingpassModal, setDataSingpassModal] = useState(false);
  const [needOtherAuthoriser, setNeedOtherAuthoriser] = useState(false);
  const [otherAuthoriserDetails, setOtherAuthoriserDetails] = useState(null);
  const [openDataIndex, setOpenDataIndex] = useState(null);
  const [keyman, setKeyman] = useState("");
  const [viewingUser, setViewingUser] = useState(0);
  const [viewingTab, setViewingTab] = useState(0);
  const [liveUserData, setLiveUserData] = useState(null);
  const [singpassData, setSingpassData] = useState(null);
  const [combinedSingpassData, setCombinedSingpassData] = useState([]);
  const [allCBSData, setAllCBSData] = useState([]);
  const [badgeVerified, setBadgeVerified] = useState(false);
  const [keymanDetails, setKeymanDetails] = useState({
    contact: "",
    email: "",
  });

  const [backupContact, setBackupContact] = useState("");
  const [notes, setNotes] = useState("");
  const [platformNotes, setPlatformNotes] = useState("");
  const [loanRemark, setLoanRemark] = useState("");
  const availableTab = [
    { name: "Personal Information" },
    { name: "Corporate Information" },
    { name: "NOA History" },
    { name: "Capitals" },
    { name: "Financials" },
    { name: "Shareholders" },
    { name: "Borrower Report" },
  ];
  const singpassDetails = async (
    user,
    other_authorization,
    loan_id,
    keyman,
    notes,
    platform_notes,
    loan_remark
  ) => {
    try {
      setKeyman(keyman);
      setNotes(notes);
      setPlatformNotes(platform_notes);
      setLoanRemark(loan_remark);
      const response = await fetch(
        `https://www.smart-lend.com/api/user/getBorrowerSingppass?user_id=${user}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      );

      const json = await response.json();
      console.log(json);
      let allSingpassData = [json.singpass_data];
      setDataSingpassModal(true);
      if (other_authorization) {
        console.log("need other authorizer");
        setNeedOtherAuthoriser(true);
        try {
          const response2 = await fetch(
            `https://www.smart-lend.com/api/loanDetails/getLoanAuthorisers`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${Cookies.get("token")}`,
              },
              body: JSON.stringify({ loan_id: loan_id }),
            }
          );

          const json2 = await response2.json();
          setOtherAuthoriserDetails(json2.authorisers);
          console.log(JSON.parse(json2.authorisers[0].singpass_data));
          console.log(json.singpass_data);
          setLiveUserData(json.singpass_data);
          console.log(json2.authorisers);

          for (const single of json2.authorisers) {
            allSingpassData.push(JSON.parse(single.singpass_data));
          }
        } catch (error) {
          console.error(error);
        }
      } else {
        console.log("Doesnt need other authoriser");
        setLiveUserData(json.singpass_data);
        setNeedOtherAuthoriser(false);
        setOtherAuthoriserDetails(null);
      }
      if (json.singpass_data) {
        setSingpassData(json.singpass_data);
        console.log(allSingpassData);
        setCombinedSingpassData(allSingpassData);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const getShareholderAddress = (data) => {
    const allSingpassData = [singpassData];
    console.log(allSingpassData, data);
    if (otherAuthoriserDetails !== null && otherAuthoriserDetails.length > 0) {
      for (const single of otherAuthoriserDetails) {
        allSingpassData.push(JSON.parse(single.singpass_data));
      }
      const toPush = allSingpassData.filter(
        (sd) => getPersonData(sd)?.name?.value === data
      );
      console.log(toPush);
      return toPush;
    } else {
      console.log(allSingpassData);
      return allSingpassData;
    }
  };

  const getInitials = (name) => {
    const textToSplit = name.split(" ");
    const initials =
      textToSplit?.[0]?.[0].toUpperCase() +
      (textToSplit?.[1]?.[0].toUpperCase() || "");
    return initials;
  };

  const ContainerActivity = ({ item, icon, title, subtitle }) => (
    <div
      style={{
        width: "100%",
        textAlign: "left",
        marginBottom: "12.5px",
        border: "none",
        borderRadius: "10px",
        backgroundColor: "transparent",
        height: "60px",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", color: "grey" }}>
        <div
          style={{
            width: "40px",
            height: "40px",
            borderRadius: "50%",
            background: "rgb(140,140,170)",
            marginLeft: "10px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer",
            color: "white",
            fontSize: 20,
            fontWeight: 600,
            cursor: "pointer",
          }}
          onClick={() => {
            console.log(item);
            setBadgeVerified(item.badge_verified);
            setBackupContact(item.user_id);
            const dataToPush = [
              {
                name: getPersonData(JSON.parse(item.singpass_data))?.name?.value,
                cbs_data: item.credit_report_data,
              },
            ];
            for (const dat of item.loan_authorizations) {
              dataToPush.push({
                name: dat.director_name,
                cbs_data: dat.credit_report_data,
              });
            }
            console.log(item);
            setAllCBSData(dataToPush);
            singpassDetails(
              item.user_id,
              item.authorization_required,
              item.loan_id,
              item.keyman,
              item.notes,
              item.platform_notes,
              item.loan_remark
            );
          }}
        >
          {title ? getInitials(title) : "SL"}
        </div>
        <div
          style={{
            height: "60px",
            width: "calc(100% - 60px)",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            marginLeft: "5px",
          }}
        >
          <h3
            style={{
              fontFamily: "Manrope, sans-serif",
              fontWeight: "800",
              fontSize: "18px",
              textAlign: "left",
              color: "rgba(20, 44, 68, 0.8)",
              margin: "0px 0px 0px 0px",
            }}
          >
            {title}
          </h3>
          <p
            style={{
              fontFamily: "Manrope, sans-serif",
              fontWeight: "600",
              fontSize: "11px",
              color: "rgba(0,0,0,0.4)",
              textAlign: "left",
              margin: "0px 0px 0px 0px",
            }}
          >
            {subtitle}
          </p>
        </div>
      </div>
    </div>
  );

  const ContainerTransaction = ({ title, label }) => (
    <div
      style={{
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "flex-start",
        marginTop: "12px",
      }}
    >
      <div style={{ flex: 1, textAlign: "left", marginLeft: "0px" }}>
        <h3
          style={{
            fontFamily: "Manrope, sans-serif",
            fontWeight: "600",
            fontSize: "11px",
            color: "rgba(0,0,0,0.4)",
            margin: "0px",
          }}
        >
          {title}
        </h3>
        <p
          style={{
            fontFamily: "Manrope, sans-serif",
            fontWeight: "800",
            fontSize: "18px",
            textAlign: "left",
            color: "rgba(20, 44, 68, 0.8)",
            margin: "0px",
          }}
        >
          {label}
        </p>
      </div>
    </div>
  );

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    // Call handleResize initially to set the initial screen width
    handleResize();

    // Add event listener for resize
    window.addEventListener("resize", handleResize);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      {isLoading ? (
        <div
          style={{
            width: "100vw",
            height: "100vh",
            position: "fixed",
            top: 0,
            left: 0,
            zIndex: 2000,
            background: "rgba(256,256,256,0.65)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress
            style={{ color: "#1677ff" }}
            size={80}
            thickness={5} // Adjust thickness as needed
          />
        </div>
      ) : null}
      {screenWidth > 1200 ? (
        <Box m="4px 20px 20px 20px">
          <Modal
            width={"60%"}
            style={{ backgroundColor: "rgba(0, 0, 0, 0)" }}
            open={dataModalIsOpen}
            onCancel={() => {
              setDataModalIsOpen(false);
            }}
            footer={null}
          >
            <Typography
              color={colors.grey[920]}
              variant="h5"
              fontWeight="800"
              fontFamily="Manrope, sans-serif"
              fontSize="22px"
            >
              Lender Stats
            </Typography>
            <div
              style={{
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "space-between",
                gap: "15px",
                marginTop: "15px",
              }}
            >
              <div
                style={{
                  width: "30%",
                  minHeight: "240px",
                  maxHeight: "450px",
                  border: `1px solid rgba(0,0,0,0.2)`,
                  borderRadius: "12px",
                  padding: "10px",
                }}
              >
                <Typography
                  color={colors.grey[920]}
                  variant="h5"
                  fontWeight="800"
                  fontFamily="Manrope, sans-serif"
                  fontSize="14px"
                >
                  Viewed By
                </Typography>
                <div>
                  {openModalData ? (
                    openModalData.viewed_by ? (
                      JSON.parse(openModalData.viewed_by).map((dat, index) => (
                        <div key={index}>
                          {allLenders.filter((das) => das.user_id === dat)
                            .length > 0
                            ? allLenders
                                .filter((das) => das.user_id === dat)?.[0]
                                ?.principal_name.slice(0, 20) +
                              (allLenders.filter(
                                (das) => das.user_id === dat
                              )?.[0]?.principal_name.length > 19
                                ? "..."
                                : "")
                            : null}
                        </div>
                      ))
                    ) : (
                      <div
                        style={{
                          width: "100%",
                          height: "200px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "rgba(0,0,0,0.15)",
                        }}
                      >
                        No Views at the moment
                      </div>
                    )
                  ) : (
                    <div
                      style={{
                        width: "100%",
                        height: "200px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "rgba(0,0,0,0.15)",
                      }}
                    >
                      No Views at the moment
                    </div>
                  )}
                </div>
              </div>
              <div
                style={{
                  width: "30%",
                  minHeight: "240px",
                  maxHeight: "450px",
                  border: `1px solid rgba(0,0,0,0.2)`,
                  borderRadius: "12px",
                  padding: "10px",
                }}
              >
                <Typography
                  color={colors.grey[920]}
                  variant="h5"
                  fontWeight="800"
                  fontFamily="Manrope, sans-serif"
                  fontSize="14px"
                >
                  Documents Downloaded By
                </Typography>
                <div>
                  {openModalData ? (
                    openModalData.download_by ? (
                      JSON.parse(openModalData.download_by).map(
                        (dat, index) => (
                          <div key={index}>
                            {allLenders.filter((das) => das.user_id === dat)
                              .length > 0
                              ? allLenders
                                  .filter((das) => das.user_id === dat)?.[0]
                                  ?.principal_name.slice(0, 20) +
                                (allLenders.filter(
                                  (das) => das.user_id === dat
                                )?.[0]?.principal_name.length > 19
                                  ? "..."
                                  : "")
                              : null}
                          </div>
                        )
                      )
                    ) : (
                      <div
                        style={{
                          width: "100%",
                          height: "200px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "rgba(0,0,0,0.15)",
                        }}
                      >
                        No Downloads at the moment
                      </div>
                    )
                  ) : (
                    <div
                      style={{
                        width: "100%",
                        height: "200px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "rgba(0,0,0,0.15)",
                      }}
                    >
                      No Downloads at the moment
                    </div>
                  )}
                </div>
              </div>
              <div
                style={{
                  width: "30%",
                  minHeight: "240px",
                  maxHeight: "450px",
                  border: `1px solid rgba(0,0,0,0.2)`,
                  borderRadius: "12px",
                  padding: "10px",
                }}
              >
                <Typography
                  color={colors.grey[920]}
                  variant="h5"
                  fontWeight="800"
                  fontFamily="Manrope, sans-serif"
                  fontSize="14px"
                >
                  Offered By
                </Typography>
                {openModalData ? (
                  openModalData.loan_offers.length > 0 ? (
                    openModalData.loan_offers.map((offer, index) => (
                      <div key={index}>
                        {allLenders.filter(
                          (das) => das.user_id === offer.user_id
                        ).length > 0
                          ? allLenders
                              .filter(
                                (das) => das.user_id === offer.user_id
                              )?.[0]
                              ?.principal_name.slice(0, 20) +
                            (allLenders.filter(
                              (das) => das.user_id === offer.user_id
                            )?.[0]?.principal_name.length > 19
                              ? "..."
                              : "")
                          : null}
                      </div>
                    ))
                  ) : (
                    <div
                      style={{
                        width: "100%",
                        height: "200px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "rgba(0,0,0,0.15)",
                      }}
                    >
                      No Offers at the moment
                    </div>
                  )
                ) : (
                  <div
                    style={{
                      width: "100%",
                      height: "200px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "rgba(0,0,0,0.15)",
                    }}
                  >
                    No Offers at the moment
                  </div>
                )}
              </div>
            </div>
          </Modal>
          <Modal
            width={"60%"}
            style={{ backgroundColor: "rgba(0, 0, 0, 0)" }}
            open={editLoanRemarkModalIsOpen}
            onCancel={() => {
              setEditLoanRemarkModalIsOpen(false);
            }}
            footer={null}
          >
            <Typography
              color={colors.grey[920]}
              variant="h5"
              fontWeight="800"
              fontFamily="Manrope, sans-serif"
              fontSize="18px"
            >
              Loan Remarks
            </Typography>
            {remarkDetails ? (
              <div>
                <div style={{ marginTop: "15px" }}>Type of Remark</div>
                <div style={{ width: "100%", marginTop: "5px" }}>
                  <select
                    style={{
                      width: "100%",
                      border: "1px solid lightgrey",
                      padding: "5px 10px",
                      borderRadius: "8px",
                    }}
                    value={remarkDetails.type}
                    onChange={(e) => {
                      setRemarkDetails({
                        ...remarkDetails,
                        type: e.target.value,
                      });
                    }}
                  >
                    <option value={"Good"}>Good</option>
                    <option value={"Bad"}>Bad</option>
                    <option value={""}>None</option>
                  </select>
                </div>
                <div style={{ marginTop: "15px" }}>Remark message</div>
                <div style={{ width: "100%", marginTop: "5px" }}>
                  <textarea
                    value={remarkDetails.message}
                    onChange={(e) => {
                      setRemarkDetails({
                        ...remarkDetails,
                        message: e.target.value,
                      });
                    }}
                    style={{
                      width: "100%",
                      border: "1px solid lightgrey",
                      padding: "5px 10px",
                      borderRadius: "8px",
                      height: "200px",
                    }}
                  />
                </div>
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                  <div
                    onClick={() => {
                      console.log(remarkDetails.loan_id, remarkDetails);
                      seditLoanRemarks(remarkDetails.loan_id, remarkDetails);
                    }}
                    style={{
                      background: "rgb(17, 92, 166)",
                      color: "white",
                      padding: "7px 30px",
                      border: "none",
                      borderRadius: "8px",
                      cursor: "pointer",
                      marginTop: "10px",
                    }}
                  >
                    Submit
                  </div>
                </div>
              </div>
            ) : null}
          </Modal>
          <Modal
            width={"60%"}
            style={{ backgroundColor: "rgba(0, 0, 0, 0)" }}
            open={editBorrowerNotesModalIsOpen}
            onCancel={() => {
              setEditBorrowerNotesModalIsOpen(false);
            }}
            footer={null}
          >
            <Typography
              color={colors.grey[920]}
              variant="h5"
              fontWeight="800"
              fontFamily="Manrope, sans-serif"
              fontSize="18px"
            >
              Loan Notes
            </Typography>
            <div>
              <div style={{ width: "100%", marginTop: "5px" }}>
                <textarea
                  value={borrowerNotes}
                  onChange={(e) => {
                    setBorrowerNotes(e.target.value);
                  }}
                  placeholder="A text area for you to explain certain financial records or set notes for our platform administrators and lenders to view."
                  style={{
                    width: "100%",
                    border: "1px solid lightgrey",
                    padding: "5px 10px",
                    borderRadius: "8px",
                    height: "200px",
                  }}
                />
              </div>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <div
                  onClick={() => {
                    editLoanNotes(notesLoanId, borrowerNotes);
                  }}
                  style={{
                    background: "rgb(17, 92, 166)",
                    color: "white",
                    padding: "7px 30px",
                    border: "none",
                    borderRadius: "8px",
                    cursor: "pointer",
                    marginTop: "10px",
                  }}
                >
                  Submit
                </div>
              </div>
            </div>
          </Modal>
          <Modal
            width={"80%"}
            style={{ backgroundColor: "rgba(0, 0, 0, 0)" }}
            open={rejectReasons !== null}
            onCancel={() => {
              setRejectReasons(null);
            }}
            footer={null}
          >
            <Typography
              color={colors.grey[920]}
              variant="h5"
              fontWeight="800"
              fontFamily="Manrope, sans-serif"
              fontSize="18px"
            >
              Reject reasons on loan
            </Typography>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "10px",
                marginTop: "15px",
              }}
            >
              {allLenders && allLenders.length > 0 && rejectReasons
                ? Object.keys(rejectReasons).map((userid, details) => (
                    <div
                      style={{
                        background: "rgba(17, 92, 166, 0.1)",
                        padding: "10px",
                        borderRadius: "6px",
                        minWidth: "300px",
                        color: "#142C44CC",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <div style={{ fontWeight: 700, fonts: "20px" }}>
                          {
                            allLenders.filter(
                              (len) => len.user_id === userid
                            )?.[0]?.principal_name
                          }
                        </div>
                        <div style={{ fontSize: "12px", color: "#142c444A" }}>
                          {formatDate(rejectReasons[userid].timestamp)}
                        </div>
                      </div>
                      <div style={{ marginTop: "8px", fontSize: "18px" }}>
                        {rejectReasons[userid].reason}
                      </div>
                    </div>
                  ))
                : null}
            </div>
          </Modal>
          <Modal
            width={"80%"}
            style={{ backgroundColor: "rgba(0, 0, 0, 0)" }}
            open={dataSingpassModal}
            onCancel={() => {
              setDataSingpassModal(false);
              setSingpassData(null);
              setOpenDataIndex(null);
              setKeyman("");
            }}
            footer={null}
          >
            {singpassData ? (
              <ProfileViewer
                keyman={keyman}
                isMobile={isMobile}
                viewingUser={viewingUser}
                setViewingUser={(data) => {
                  setViewingUser(data);
                }}
                singpassData={singpassData}
                liveUserData={liveUserData}
                otherAuthoriserDetails={otherAuthoriserDetails}
                setLiveUserData={(data) => {
                  setLiveUserData(data);
                }}
                setViewingTab={(data) => {
                  setViewingTab(data);
                }}
                viewingTab={viewingTab}
                badgeVerified={badgeVerified}
                availableTab={availableTab}
                allCBSData={allCBSData}
                combinedSingpassData={combinedSingpassData}
                getShareholderAddress={(data) => {
                  getShareholderAddress(data);
                }}
                backupContact={backupContact}
                notes={notes}
                platform_notes={platformNotes}
                loan_remark={loanRemark}
              />
            ) : (
              <div></div>
            )}
          </Modal>
          <Box
            display="grid"
            gridTemplateColumns="repeat(12, 1fr)"
            gridAutoRows="140px"
            gap="20px"
          >
            <Box
              gridColumn="span 9"
              gridRow="span 2"
              height="100vh"
              width="100%"
              borderRadius="10px"
              border="0px solid "
              opacity="0.95"
              style={{
                overflowY: "scroll",
                overflowX: "scroll",
                background:
                  "transparent linear-gradient(180deg, #FFFFFFB3 0%, #FFFFFF00 100%) 0% 0% no-repeat padding-box",
              }}
            >
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                width="100%"
                borderRadius="10px"
                margin="20px 20px 20px 20px"
              >
                <Typography
                  color={colors.grey[920]}
                  variant="h5"
                  fontWeight="800"
                  fontFamily="Manrope, sans-serif"
                  fontSize="18px"
                >
                  Requested Loan
                </Typography>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginRight: "38px",
                  }}
                >
                  <label
                    htmlFor="sort-by"
                    style={{
                      width: "50%",
                      color: "#142C44CC",
                      fontWeight: "800",
                      fontSize: "13px",
                      fontFamily: "Manrope, sans-serif",
                      marginRight: "-5px",
                    }}
                  >
                    Sort by:
                  </label>
                  <div style={{ width: "80%", marginRight: "10px" }}>
                    <select
                      id="sort-by"
                      value={sortBy}
                      onChange={(e) => setSortBy(e.target.value)}
                      style={{
                        width: "100%",
                        borderRadius: "30px",
                        color: "#0E5AA5",
                        backgroundColor: "#ECF0F5",
                        border: "1px solid #3E536733",
                        marginRight: "15px",
                        fontWeight: "600",
                        fontFamily: "Poppins, sans-serif",
                        fontSize: "13px",
                      }}
                    >
                      <option
                        style={{
                          fontWeight: "600",
                          fontFamily: "Poppins, sans-serif",
                          fontSize: "13px",
                        }}
                        value="default"
                      >
                        Date & Time
                      </option>
                      <option
                        style={{
                          fontWeight: "600",
                          fontFamily: "Poppins, sans-serif",
                          fontSize: "13px",
                        }}
                        value="loan-amount"
                      >
                        Loan Amount
                      </option>
                      <option
                        style={{
                          fontWeight: "600",
                          fontFamily: "Poppins, sans-serif",
                          fontSize: "13px",
                        }}
                        value="date"
                      >
                        Date
                      </option>
                    </select>
                  </div>
                  {/* <button onClick={(event) => showModal(selectedBorrowerIds, event)} style={{ backgroundColor: "white", borderRadius: "10px", color: "#B13434", border: "1px solid #B13434", fontWeight: "600", fontFamily: "Poppins, sans-serif", fontSize: "13px", width:"80%" }}>Warn Borrower</button> */}
                </div>
              </Box>

              <Box>
                <TableAdminLoanRequest
                  onRowClick={handleRowClick}
                  onSelectionChange={handleSelectionChange}
                  removedLoan={removeLoan}
                />
              </Box>
            </Box>

            <Box
              gridColumn="span 3"
              gridRow="span 2"
              height="89vh"
              borderRadius="10px"
              border="0px solid white"
              style={{
                background:
                  "transparent linear-gradient(0deg, #FFFFFFB3 0%, #FFFFFF00 100%) 0% 0% no-repeat padding-box",
              }}
            >
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                // borderBottom={`4px solid ${colors.primary[500]}`}
                colors={colors.grey[910]}
                marginTop="-15px"
                marginBottom="10px"
                p="15px"
              >
                <Typography
                  color={colors.grey[920]}
                  variant="h5"
                  fontWeight="800"
                  fontFamily="Manrope, sans-serif"
                  fontSize="18px"
                >
                  Requested Loan Details
                </Typography>
              </Box>
              <Box
                display="flex"
                flexDirection="column"
                backgroundColor="#FFFFFF"
                borderRadius="10px"
                margin="-10px 10px"
                style={{
                  overflowY: "scroll",
                }}
                p="15px"
                height="83.7vh"
              >
                {data && data.length > 0 ? (
                  data.map((item) => (
                    <Box
                      key={item.id}
                      display="flex"
                      justifyContent="center"
                      alignItems="flex-start" // Updated to align to the top
                      colors={colors.grey[910]}
                      // borderBottom={`1px solid ${colors.primary[500]}`}
                      width="100%"
                      textAlign="center"
                      margin="0px"
                      flexDirection="column"
                    >
                      <ContainerActivity
                        item={item}
                        icon="https://www.shutterstock.com/image-photo/kiev-ukraine-march-31-2015-260nw-270200051.jpg" //map to data laterwards
                        title={item.principal_name || "Hello World"}
                        subtitle={
                          item.category
                            ? item.category.charAt(0).toUpperCase() +
                              item.category.slice(1)
                            : "-"
                        }
                      />
                      <div
                        style={{
                          borderBottom: "2px solid black",
                          width: "100%",
                          opacity: "0.3",
                        }}
                      />
                    </Box>
                  ))
                ) : (
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    colors={colors.grey[910]}
                    width="100%"
                    textAlign="center"
                    margin="1px 1px 1px 0px"
                    flexDirection="column"
                    height="80vh"
                  >
                    <ContainerActivity
                      icon={warn_ico}
                      title="Please Click on Table Row to View Details"
                    />
                  </Box>
                )}
                {!data && (
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    colors={colors.grey[910]}
                    width="100%"
                    textAlign="center"
                    margin="0px"
                    flexDirection="column"
                  >
                    <ContainerActivity
                      icon="https://www.shutterstock.com/image-photo/kiev-ukraine-march-31-2015-260nw-270200051.jpg"
                      title="NO VALUE HERE"
                      subtitle="NO VALUE HERE"
                    />
                    <div
                      style={{
                        borderBottom: "2px solid black",
                        width: "100%",
                        opacity: "0.3",
                      }}
                    />
                  </Box>
                )}

                {/* <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  colors={colors.grey[910]}
                  marginLeft="0px"
                >
                  {data &&
                    data.length > 0 &&
                    data.map((item) => (
                      <ContainerTransaction
                        title="Loan ID"
                        label={item.loan_id || "-"}
                      />
                    ))}
                </Box> */}
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  colors={colors.grey[910]}
                  marginLeft="0px"
                  marginTop="0px"
                  onClick={() => {
                    console.log(data[0] ? data[0] : null);
                    setOpenModalData(data[0] ? data[0] : null);
                    setDataModalIsOpen(true);
                  }}
                >
                  {data &&
                    data.length > 0 &&
                    data.map((item) => (
                      <ContainerTransaction
                        title="Created At"
                        label={formatDate(item.created_at) || "-"}
                      />
                    ))}
                </Box>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  colors={colors.grey[910]}
                  marginLeft="0px"
                  marginTop="0px"
                  onClick={() => {
                    setOpenModalData(data[0] ? data[0] : null);
                    setDataModalIsOpen(true);
                  }}
                >
                  {data &&
                    data.length > 0 &&
                    data.map((item) => (
                      <ContainerTransaction
                        title="Expired Date"
                        label={formatDate(item.expired_date) || "-"}
                      />
                    ))}
                </Box>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  colors={colors.grey[910]}
                  marginLeft="0px"
                  marginTop="0px"
                  onClick={() => {
                    setOpenModalData(data[0] ? data[0] : null);
                    setDataModalIsOpen(true);
                  }}
                >
                  {data &&
                    data.length > 0 &&
                    data.map((item) => (
                      <ContainerTransaction
                        title="Amount"
                        label={
                          item.request_amount.toLocaleString("en-US", {
                            style: "currency",
                            currency: "SGD",
                          }) || "-"
                        }
                      />
                    ))}
                </Box>

                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  colors={colors.grey[910]}
                  marginLeft="0px"
                  marginTop="0px"
                  onClick={() => {
                    setOpenModalData(data[0] ? data[0] : null);
                    setDataModalIsOpen(true);
                  }}
                >
                  {data &&
                    data.length > 0 &&
                    data.map((item) => (
                      <ContainerTransaction
                        title="Interest Rate"
                        label={
                          item.request_interest_rate
                            ? (item.request_interest_rate * 100).toFixed(1) +
                              "%"
                            : "-"
                        }
                      />
                    ))}
                </Box>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  colors={colors.grey[910]}
                  marginLeft="0px"
                  marginTop="0px"
                  onClick={() => {
                    setOpenModalData(data[0] ? data[0] : null);
                    setDataModalIsOpen(true);
                  }}
                >
                  {data &&
                    data.length > 0 &&
                    data.map((item) => (
                      <ContainerTransaction
                        title="Total Interest"
                        label={
                          item.total_interest.toLocaleString("en-US", {
                            style: "currency",
                            currency: "SGD",
                          }) || "-"
                        }
                      />
                    ))}
                </Box>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  colors={colors.grey[910]}
                  marginLeft="0px"
                  marginTop="0px"
                  onClick={() => {
                    setOpenModalData(data[0] ? data[0] : null);
                    setDataModalIsOpen(true);
                  }}
                >
                  {data &&
                    data.length > 0 &&
                    data.map((item) => (
                      <ContainerTransaction
                        title="Period"
                        label={item.request_period + " Months" || "-"}
                      />
                    ))}
                </Box>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  colors={colors.grey[910]}
                  marginLeft="0px"
                  marginTop="0px"
                  onClick={() => {
                    setOpenModalData(data[0] ? data[0] : null);
                    setDataModalIsOpen(true);
                  }}
                >
                  {data &&
                    data.length > 0 &&
                    data.map((item) => (
                      <ContainerTransaction
                        title="Admin Fee"
                        label={`${(item.admin_fee * 100).toFixed(1)}%` || "-"}
                      />
                    ))}
                </Box>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  colors={colors.grey[910]}
                  marginLeft="0px"
                  marginTop="0px"
                  onClick={() => {
                    setOpenModalData(data[0] ? data[0] : null);
                    setDataModalIsOpen(true);
                  }}
                >
                  {data &&
                    data.length > 0 &&
                    data.map((item) => (
                      <ContainerTransaction
                        title="Request Monthly Installment"
                        label={
                          item.request_monthly_installment.toLocaleString(
                            "en-US",
                            { style: "currency", currency: "SGD" }
                          ) || "-"
                        }
                      />
                    ))}
                </Box>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  colors={colors.grey[910]}
                  marginLeft="0px"
                  marginTop="0px"
                  onClick={() => {
                    setOpenModalData(data[0] ? data[0] : null);
                    setDataModalIsOpen(true);
                  }}
                >
                  {data &&
                    data.length > 0 &&
                    data.map((item) => (
                      <ContainerTransaction
                        title="Principal"
                        label={
                          item.request_principal.toLocaleString("en-US", {
                            style: "currency",
                            currency: "SGD",
                          }) || "-"
                        }
                      />
                    ))}
                </Box>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  colors={colors.grey[910]}
                  marginLeft="0px"
                  marginTop="0px"
                >
                  {data &&
                    data.length > 0 &&
                    data.map((item) =>
                      item.reject_reason ? (
                        <div
                          style={{
                            textAlign: "center",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "flex-start",
                            marginTop: "12px",
                          }}
                        >
                          <h3
                            style={{
                              fontFamily: "Manrope, sans-serif",
                              fontWeight: "600",
                              fontSize: "11px",
                              color: "rgba(0,0,0,0.4)",
                              margin: "0px",
                            }}
                          >
                            Reject reasons
                          </h3>
                          <p
                            style={{
                              fontFamily: "Manrope, sans-serif",
                              fontWeight: "800",
                              fontSize: "18px",
                              textAlign: "left",
                              color: "rgba(20, 44, 68, 0.8)",
                              margin: "0px",
                            }}
                          >
                            <div
                              onClick={(e) => {
                                e.stopPropagation();
                                console.log(JSON.parse(item.reject_reason));
                                setRejectReasons(
                                  JSON.parse(item.reject_reason)
                                );
                              }}
                              style={{
                                background: "rgb(17, 92, 166)",
                                color: "white",
                                padding: "7px 30px",
                                border: "none",
                                borderRadius: "8px",
                                cursor: "pointer",
                                marginTop: "10px",
                              }}
                            >
                              View reasons
                            </div>
                          </p>
                        </div>
                      ) : null
                    )}
                </Box>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  colors={colors.grey[910]}
                  marginLeft="0px"
                  marginTop="0px"
                >
                  {data &&
                    data.length > 0 &&
                    data.map((item) => (
                      <ContainerTransaction
                        title="Upload Doc to Loan"
                        label={
                          <div>
                            <div
                              onClick={(e) => {
                                console.log(item?.principal_name);
                                handleClickUpload(
                                  item?.loan_id,
                                  e,
                                  item?.principal_name
                                );
                              }}
                              style={{
                                background: "rgb(17, 92, 166)",
                                color: "white",
                                padding: "7px 30px",
                                border: "none",
                                borderRadius: "8px",
                                cursor: "pointer",
                                marginTop: "10px",
                              }}
                            >
                              Upload
                            </div>
                            <input
                              ref={fileInputRef}
                              type="file"
                              accept="application/pdf,image/*" // tweak as needed
                              style={{ display: "none" }}
                              onChange={handleFileChange}
                            />
                          </div>
                        }
                      />
                    ))}
                </Box>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  colors={colors.grey[910]}
                  marginLeft="0px"
                  marginTop="0px"
                >
                  {data &&
                    data.length > 0 &&
                    data.map((item) => (
                      <ContainerTransaction
                        title="Download Bank Statement"
                        label={
                          <div
                            onClick={(e) => {
                              e.stopPropagation();
                              downloadLoanDocuments(item?.loan_id);
                              // window.open(item?.bank_statement);
                            }}
                            style={{
                              background: "rgb(17, 92, 166)",
                              color: "white",
                              padding: "7px 30px",
                              border: "none",
                              borderRadius: "8px",
                              cursor: "pointer",
                              marginTop: "10px",
                            }}
                          >
                            Download
                          </div>
                        }
                      />
                    ))}
                </Box>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  colors={colors.grey[910]}
                  marginLeft="0px"
                  marginTop="0px"
                >
                  {data &&
                    data.length > 0 &&
                    data.map((item) =>
                      item.authorization_required ? (
                        <ContainerTransaction
                          title="Overwrite Authentication"
                          label={
                            <div
                              onClick={(e) => {
                                e.stopPropagation();
                                console.log(item?.loan_id);
                                overwriteLoanAuthentications(item?.loan_id);
                                // window.open(item?.bank_statement);
                              }}
                              style={{
                                background: "rgb(17, 92, 166)",
                                color: "white",
                                padding: "7px 30px",
                                border: "none",
                                borderRadius: "8px",
                                cursor: "pointer",
                                marginTop: "10px",
                              }}
                            >
                              Overwrite
                            </div>
                          }
                        />
                      ) : null
                    )}
                </Box>

                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  colors={colors.grey[910]}
                  marginLeft="0px"
                  marginTop="0px"
                >
                  {data &&
                    data.length > 0 &&
                    data.map((item) => (
                      <div
                        style={{
                          textAlign: "center",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "flex-start",
                          marginTop: "12px",
                        }}
                      >
                        <h3
                          style={{
                            fontFamily: "Manrope, sans-serif",
                            fontWeight: "600",
                            fontSize: "11px",
                            color: "rgba(0,0,0,0.4)",
                            margin: "0px",
                          }}
                        >
                          Loan remark
                        </h3>
                        <p
                          style={{
                            fontFamily: "Manrope, sans-serif",
                            fontWeight: "800",
                            fontSize: "18px",
                            textAlign: "left",
                            color: "rgba(20, 44, 68, 0.8)",
                            margin: "0px",
                          }}
                        >
                          <div
                            onClick={(e) => {
                              e.stopPropagation();
                              setEditLoanRemarkModalIsOpen(true);
                              setRemarkDetails(
                                item.loan_remark
                                  ? JSON.parse(item.loan_remark)
                                  : {
                                      loan_id: item.loan_id,
                                      type: "Good",
                                      message: "",
                                    }
                              );
                            }}
                            style={{
                              background: "rgb(17, 92, 166)",
                              color: "white",
                              padding: "7px 30px",
                              border: "none",
                              borderRadius: "8px",
                              cursor: "pointer",
                              marginTop: "10px",
                            }}
                          >
                            Edit Loan Remark
                          </div>
                          <div
                            onClick={(e) => {
                              e.stopPropagation();
                              setEditBorrowerNotesModalIsOpen(true);
                              setBorrowerNotes(item.platform_notes);
                              setNotesLoanId(item.loan_id);
                              console.log(item.platform_notes);
                              console.log(item.loan_id);
                            }}
                            style={{
                              background: "rgb(17, 92, 166)",
                              color: "white",
                              padding: "7px 30px",
                              border: "none",
                              borderRadius: "8px",
                              cursor: "pointer",
                              marginTop: "10px",
                            }}
                          >
                            Edit Borrower Notes
                          </div>
                        </p>
                      </div>
                    ))}
                </Box>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  colors={colors.grey[910]}
                  marginLeft="0px"
                  marginTop="0px"
                >
                  {data &&
                    data.length > 0 &&
                    data.map((item) => (
                      <ContainerTransaction
                        title="Remove/Delete loan"
                        label={
                          <div style={{ display: "flex", gap: "10px" }}>
                            {!item.admin_removal ? (
                              <div
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleAdminRemoval({
                                    loan_id: item?.loan_id,
                                    boolean: 1,
                                  });
                                }}
                                style={{
                                  background: "rgb(17, 92, 166)",
                                  color: "white",
                                  padding: "7px 30px",
                                  border: "none",
                                  borderRadius: "8px",
                                  cursor: "pointer",
                                  marginTop: "10px",
                                }}
                              >
                                Remove
                              </div>
                            ) : (
                              <div
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleAdminRemoval({
                                    loan_id: item?.loan_id,
                                    boolean: 0,
                                  });
                                }}
                                style={{
                                  background: "rgb(17, 92, 166)",
                                  color: "white",
                                  padding: "7px 30px",
                                  border: "none",
                                  borderRadius: "8px",
                                  cursor: "pointer",
                                  marginTop: "10px",
                                }}
                              >
                                Push
                              </div>
                            )}
                            <div
                              onClick={(e) => {
                                e.stopPropagation();
                                handleLoanDelete(item?.loan_id);
                              }}
                              style={{
                                background: "rgb(17, 92, 166)",
                                color: "white",
                                padding: "7px 30px",
                                border: "none",
                                borderRadius: "8px",
                                cursor: "pointer",
                                marginTop: "10px",
                              }}
                            >
                              Delete
                            </div>
                          </div>
                        }
                      />
                    ))}
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      ) : (
        <div>
          <div
            style={{
              background:
                "transparent linear-gradient(180deg, #FFFFFFB3 0%, #FFFFFF00 100%) 0% 0% no-repeat padding-box",
              padding: "0px 20px",
              height: "100vh",
              borderRadius: "20px",
              width: "95%",
              marginLeft: "10px",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                paddingTop: "10px",
                width: "100%",
              }}
            >
              <Typography
                color={colors.grey[920]}
                variant="h5"
                fontWeight="800"
                fontFamily="Manrope, sans-serif"
                fontSize="20px"
              >
                Requested Loan
              </Typography>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  width: "33%",
                }}
              >
                <div style={{ width: "100%" }}>
                  <label
                    htmlFor="sort-by"
                    style={{
                      color: "#142C44CC",
                      fontWeight: "800",
                      fontSize: "10px",
                      fontFamily: "Manrope, sans-serif",
                    }}
                  >
                    Sort by:
                  </label>

                  <select
                    id="sort-by"
                    value={sortBy}
                    onChange={(e) => setSortBy(e.target.value)}
                    style={{
                      width: "100%",
                      borderRadius: "30px",
                      color: "#0E5AA5",
                      backgroundColor: "#ECF0F5",
                      border: "1px solid #3E536733",
                      fontWeight: "600",
                      fontFamily: "Poppins, sans-serif",
                      fontSize: "11px",
                    }}
                  >
                    <option value="default">Date & Time</option>
                    <option value="loan-amount">Loan Amount</option>
                    <option value="date">Date</option>
                  </select>
                </div>
              </div>
            </div>
            <div>
              <TableAdminLoanRequest
                onRowClick={handleRowClick}
                onSelectionChange={handleSelectionChange}
              />
            </div>
            <div
              style={{
                height: "89vh",
                borderRadius: "20px",
                border: "0px solid white",
                background:
                  "transparent linear-gradient(0deg, #FFFFFFB3 0%, #FFFFFF00 100%) 0% 0% no-repeat padding-box",
              }}
            >
              <div>
                <Typography
                  color={colors.grey[920]}
                  variant="h5"
                  fontWeight="800"
                  fontFamily="Manrope, sans-serif"
                  fontSize="20px"
                  marginTop="10px"
                >
                  Requested Loan Details
                </Typography>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  backgroundColor: "#FFFFFF",
                  borderRadius: "20px",
                  overflowY: "scroll",
                  height: "83.7vh",
                }}
              >
                {data && data.length > 0 ? (
                  data.map((item) => (
                    <Box
                      key={item.id}
                      display="flex"
                      justifyContent="center"
                      alignItems="flex-start" // Updated to align to the top
                      colors={colors.grey[910]}
                      // borderBottom={`1px solid ${colors.primary[500]}`}
                      width="45%"
                      textAlign="center"
                      margin="1px 1px 1px 30px"
                      flexDirection="column"
                    >
                      <ContainerActivity
                        icon="https://www.shutterstock.com/image-photo/kiev-ukraine-march-31-2015-260nw-270200051.jpg" //map to data laterwards
                        title={item.loan_id || "Hello World"}
                        subtitle={
                          item.category
                            ? item.category.charAt(0).toUpperCase() +
                              item.category.slice(1)
                            : "-"
                        }
                      />
                      <div
                        style={{
                          borderBottom: "2px solid black",
                          width: "190%",
                          opacity: "0.3",
                        }}
                      />
                    </Box>
                  ))
                ) : (
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    colors={colors.grey[910]}
                    width="100%"
                    textAlign="center"
                    margin="1px 1px 1px 0px"
                    flexDirection="column"
                    height="80vh"
                  >
                    <ContainerActivity
                      icon={warn_ico}
                      title="Please Click on Table Row to View Details"
                    />
                  </Box>
                )}
                {!data && (
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    colors={colors.grey[910]}
                    width="45%"
                    textAlign="center"
                    margin="1px 1px 1px 30px"
                    flexDirection="column"
                  >
                    <ContainerActivity
                      icon="https://www.shutterstock.com/image-photo/kiev-ukraine-march-31-2015-260nw-270200051.jpg"
                      title="NO VALUE HERE"
                      subtitle="NO VALUE HERE"
                    />
                    <div
                      style={{
                        borderBottom: "2px solid black",
                        width: "190%",
                        opacity: "0.3",
                      }}
                    />
                  </Box>
                )}

                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  colors={colors.grey[910]}
                  marginLeft="0px"
                >
                  {data &&
                    data.length > 0 &&
                    data.map((item) => (
                      <ContainerTransaction
                        title="Lender"
                        label={item.principal_name || "-"}
                      />
                    ))}
                </Box>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  colors={colors.grey[910]}
                  marginLeft="0px"
                  marginTop="0px"
                >
                  {data &&
                    data.length > 0 &&
                    data.map((item) => (
                      <ContainerTransaction
                        title="Type"
                        label={
                          item.type
                            ? item.type.charAt(0).toUpperCase() +
                              item.type.slice(1)
                            : "-"
                        }
                      />
                    ))}
                </Box>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  colors={colors.grey[910]}
                  marginLeft="0px"
                  marginTop="0px"
                >
                  {data &&
                    data.length > 0 &&
                    data.map((item) => (
                      <ContainerTransaction
                        title="Status"
                        label={
                          item.type
                            ? item.type.charAt(0).toUpperCase() +
                              item.type.slice(1)
                            : "-"
                        }
                      />
                    ))}
                </Box>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  colors={colors.grey[910]}
                  marginLeft="0px"
                  marginTop="0px"
                >
                  {data &&
                    data.length > 0 &&
                    data.map((item) => (
                      <ContainerTransaction
                        title="Created At"
                        label={formatDate(item.created_at) || "-"}
                      />
                    ))}
                </Box>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  colors={colors.grey[910]}
                  marginLeft="0px"
                  marginTop="0px"
                >
                  {data &&
                    data.length > 0 &&
                    data.map((item) => (
                      <ContainerTransaction
                        title="Expired Date"
                        label={formatDate(item.expired_date) || "-"}
                      />
                    ))}
                </Box>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  colors={colors.grey[910]}
                  marginLeft="0px"
                  marginTop="0px"
                >
                  {data &&
                    data.length > 0 &&
                    data.map((item) => (
                      <ContainerTransaction
                        title="Amount"
                        label={
                          item.request_amount.toLocaleString("en-US", {
                            style: "currency",
                            currency: "SGD",
                          }) || "-"
                        }
                      />
                    ))}
                </Box>

                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  colors={colors.grey[910]}
                  marginLeft="0px"
                  marginTop="0px"
                >
                  {data &&
                    data.length > 0 &&
                    data.map((item) => (
                      <ContainerTransaction
                        title="Interest Rate"
                        label={
                          item.request_interest_rate
                            ? item.request_interest_rate * 100 + "%"
                            : "-"
                        }
                      />
                    ))}
                </Box>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  colors={colors.grey[910]}
                  marginLeft="0px"
                  marginTop="0px"
                >
                  {data &&
                    data.length > 0 &&
                    data.map((item) => (
                      <ContainerTransaction
                        title="Total Interest"
                        label={
                          item.total_interest.toLocaleString("en-US", {
                            style: "currency",
                            currency: "SGD",
                          }) || "-"
                        }
                      />
                    ))}
                </Box>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  colors={colors.grey[910]}
                  marginLeft="0px"
                  marginTop="0px"
                >
                  {data &&
                    data.length > 0 &&
                    data.map((item) => (
                      <ContainerTransaction
                        title="Period"
                        label={item.request_period + " Months" || "-"}
                      />
                    ))}
                </Box>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  colors={colors.grey[910]}
                  marginLeft="0px"
                  marginTop="0px"
                >
                  {data &&
                    data.length > 0 &&
                    data.map((item) => (
                      <ContainerTransaction
                        title="Admin Fee"
                        label={
                          item.admin_fee.toLocaleString("en-US", {
                            style: "currency",
                            currency: "SGD",
                          }) || "-"
                        }
                      />
                    ))}
                </Box>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  colors={colors.grey[910]}
                  marginLeft="0px"
                  marginTop="0px"
                >
                  {data &&
                    data.length > 0 &&
                    data.map((item) => (
                      <ContainerTransaction
                        title="Request Monthly Installment"
                        label={
                          item.request_monthly_installment.toLocaleString(
                            "en-US",
                            { style: "currency", currency: "SGD" }
                          ) || "-"
                        }
                      />
                    ))}
                </Box>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  colors={colors.grey[910]}
                  marginLeft="0px"
                  marginTop="0px"
                >
                  {data &&
                    data.length > 0 &&
                    data.map((item) => (
                      <ContainerTransaction
                        title="Principal"
                        label={
                          item.request_principal.toLocaleString("en-US", {
                            style: "currency",
                            currency: "SGD",
                          }) || "-"
                        }
                      />
                    ))}
                </Box>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default RequestedLoan;
